module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.polls.black-1f03f6e11dd652889e3f68e55e8368fe.svg";